import dateTimeService from "app/services/date-time/dateTimeService";
import { ONE_DAY, ONE_HOUR } from "../../../pages/management/constants/constants";

export const salesforceFormatDate = (
    date: string,
    minutesText?: string,
    hoursText?: string,
    daysText?: string,
): string => {
    const minutes = dateTimeService.getDateDiffFromNowLocal(date, "minute");

    if (minutes < ONE_HOUR) {
        return `${minutes} ${minutesText}`;
    }

    if (minutes < ONE_DAY) {
        const hours = dateTimeService.getDateDiffFromNowLocal(date, "hours");
        return `${hours} ${hoursText}`;
    }

    const days = dateTimeService.getDateDiffFromNowLocal(date, "days");
    return `${days} ${daysText}`;
};
